import React, { createContext, useContext, useState } from 'react';
import { Lang, translations } from './translations';

interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (typeof translations)['en'];
}

const detectLanguage = (): Lang =>
  navigator.language.startsWith('fr') ? 'fr' : 'en';

const LanguageContext = createContext<LanguageContextType>(
  {} as LanguageContextType
);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [lang, setLang] = useState<Lang>(detectLanguage);
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
